// @flow

import React, {Component, PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';


// -- constants
import ApiConstants from '../../constants/ApiConstants';
import ViewConstants from '../../constants/ViewConstants';

// -- tools
import ViewUtils from '../../utils/ViewUtils';
import classNames from 'classnames';

// -- views
import Dropzone from 'react-dropzone';
import CropImageModal from './CropImageModal';
import ImageLoader from '../ImageLoader';

/**
 *
 */
class ImageDropzone extends PureComponent {

  static defaultProps = {
    maxSize: ApiConstants.Image.MAX_SIZE,

    aspectRatio: (16 / 9),

    currentImage: null,

    image: null,

    className: '',

    readOnly: false,

    width: null,

    height: null,

    removeOriginalImage: null,

    editOnly: true
  };

  static propTypes = {
    placeholder: PropTypes.string.isRequired,

    currentImage: PropTypes.string,

    image: PropTypes.string,

    className: PropTypes.string,

    /*
     * @param String (data base64) The cropped image
     * @param String (data base64) The full size image
     */
    onChange: PropTypes.func.isRequired,

    maxSize: PropTypes.number,

    aspectRatio: PropTypes.number,

    readOnly: PropTypes.bool,

    editOnly: PropTypes.bool,

    /**
     * The width to set to the cropped image.
     * @type {[type]}
     */
    width: PropTypes.number,

    /**
     * The height to set to the cropped image.
     */
    height: PropTypes.number
  };

  state = {
    imageFile: null,

    displayCrop: false
  };

  // -- actions picture
  onPictureCropChange = (dataPng: string) => {
    ViewUtils.fileToDataUri(this.state.imageFile, (data) => {
      this.props.onChange(dataPng, data);
    });
  };

  onRestorePicture = () => {
    this.props.onChange(null);
  };

  onDeletePicture = () => {
    this.props.onRemove();
  }

  onPictureChange = (files: Array<Object>) => {
    const file = files[0];
    const filesize = file.size;

    if (filesize >= this.props.maxSize) {
      // TODO: check the filesize.
    }

    this.setState({
      imageFile: file,
      displayCrop: true
    });
  };

  onHideCropImageModal = () => {
    this.setState({
      displayCrop: false
    });
  };


  // -- renderers

  render() {
    const pictureClassName = classNames('image_dropzone__picture', this.props.className);

    let pictureView = (null);
    let optionView = (null);

    if (!_.isNil(this.props.currentImage)) {
      pictureView = (
        <ImageLoader
          className={pictureClassName}
          src={this.props.currentImage}
          placeholder={ViewConstants.IMAGE_UPLOAD_PLACEHOLDER()}
        />
      );
    } else if (!_.isEmpty(this.props.image)) {
      pictureView = (
        <ImageLoader
          className={pictureClassName}
          src={this.props.image}
          placeholder={ViewConstants.IMAGE_UPLOAD_PLACEHOLDER()}
        />
      );

      if (!this.props.editOnly) {
        optionView = (
          <i
            className="upload_delete_icon fa fa-trash fa-2x"
            title={I18n.tr('components.image_dropzone.delete')}
            onClick={this.onDeletePicture}
          ></i>
        );
      }
    } else {
      pictureView = (
        <ImageLoader
          className={pictureClassName}
          src={this.props.placeholder}
          placeholder={ViewConstants.IMAGE_UPLOAD_PLACEHOLDER()}
        />
      );
    }

    const style = {
      border: 'none'
    };

    if (this.props.readOnly) {
      return (
        <div className="image_dropzone">
          <div>
            {pictureView}
          </div>
        </div>
      );
    }

    return (
      <div className="image_dropzone">
        <div>
          <Dropzone
            ref="dropzone"
            onDrop={this.onPictureChange}
            multiple={false}
            accept="image/*"
            style={style}
          >
            <i
              className="upload_update_icon fa fa-edit fa-2x"
              title={I18n.tr('components.image_dropzone.edit')}
            ></i>

            {pictureView}
          </Dropzone>
          {optionView}

          {this.state.displayCrop &&
            <CropImageModal
              show={!_.isNull(this.state.imageFile) && this.state.displayCrop}
              onHide={this.onHideCropImageModal}
              imageUrl={this.state.imageFile.preview}
              aspectRatio={this.props.aspectRatio}
              onValidate={this.onPictureCropChange}
              width={this.props.width}
              height={this.props.height}
            />
          }
        </div>
      </div>
    );
  }
}

export default ImageDropzone;
